export const SELECTORS = {
  CONTAINER: 'js-countdown-timer-container',
  DAY: 'js-countdown-timer-day',
  HOUR: 'js-countdown-timer-hour',
  MINUTE: 'js-countdown-timer-minute',
  SECOND: 'js-countdown-timer-second'
};
